
import { EFilter } from '@/helpers/enums'
import { paginationLength } from '@/helpers/search'

export default {
  name: 'Pagination',

  props: {
    isHeader: Boolean,
    totalResults: {
      type: Number,
      default: 0
    },
    totalPageResults: {
      type: Number,
      default: 0
    },
    currentOffset: {
      type: Number,
      default: 0
    },
    totalVisible: {
      type: Number,
      default: 0
    }
  },

  data: () => ({
    isMounted: false
  }),

  computed: {
    showingListInfo() {
      const checkData = this.totalResults > 0 ? this.currentOffset + 1 : 0

      return this.$t('talent.project.search.show.search.details', {
        which: `${checkData} - ${this.currentOffset + this.totalPageResults}`,
        total: this.totalResults
      })
    },

    visiblePagination() {
      if (this.$vuetify.breakpoint.smAndDown && !this.isMounted) return 0
      return paginationLength(this.totalResults, this.totalVisible) > 6 ? 6 : undefined
    },

    selectedPage: {
      get() {
        return Number(this.$route.query?.page) || 1
      },
      async set(num) {
        this.$emit('before-update')

        await new Promise((resolve, reject) =>
          this.$router.push(
            {
              query: {
                ...this.$route.query,
                [EFilter.PAGE]: num
              }
            },
            resolve,
            reject
          )
        )

        this.$emit('updated')
        this.resetFocus()
      }
    }
  },

  mounted() {
    this.isMounted = true
  },

  methods: {
    paginationLength(total, size) {
      return paginationLength(total, size)
    },

    resetFocus() {
      const focusableElements = document.querySelectorAll('[tabindex]')

      if (focusableElements.length) {
        if (focusableElements[0]) {
          focusableElements[0].focus()
        }
      }
    }
  }
}
